import { useLoaderData, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import classes from "./Toolbar.module.css";
import style from "./Toolbar-theme-2.module.css";
import NewsComponent from "../../pages/Events/NewsComponent";
import WidgetsIcon from "../../icons/WidgetsIcon";
import HistoryIcon from "../../icons/HistoryIcon";
import RubleIcon from "../../icons/RubleIcon";
import AutomationIcon from "../../icons/AutomationIcon";
import { ReactNode, useEffect, useState } from "react";
import WalletIcon from "../../icons/WalletIcon";
import GuideIcon from "../../icons/GuideIcon";
import IntegrationIcon from "../../icons/IntegrationIcon";
import { WidgetData } from "../../types/WidgetData";

enum Page {
  WIDGETS,
  GATEWAYS,
  PAYMENTPAGE,
  HISTORY,
  AUTOMATION,
  COMMANDSREWARDS,
  LOYALTY,
  GUIDES,
  INTEGRATIONS,
  BOTS,
  API,
  ACCOUNT,
}

interface Section {
  page: Page;
  url: string;
  active: ReactNode;
  nonactive: ReactNode;
  label: string;
}

const allButtons: Section[] = [
  {
    page: Page.WIDGETS,
    url: "/configuration/widgets",
    active: <WidgetsIcon color="var(--oda-color-800)" />,
    nonactive: <WidgetsIcon color="var(--oda-color-500)" />,
    label: "menu-widgets",
  },
  // {
  //   page: Page.COMMANDSREWARDS,
  //   url: "/configuration/commands-rewards-page",
  //   active: (
  //     <span
  //       className="material-symbols-sharp"
  //       style={{ color: "var(--oda-color-800)", marginRight: "3px" }}
  //     >
  //       workspace_premium
  //     </span>
  //   ),
  //   nonactive: (
  //     <span
  //       className="material-symbols-sharp"
  //       style={{ color: "var(--oda-color-500)", marginRight: "3px" }}
  //     >
  //       workspace_premium
  //     </span>
  //   ),
  //   label: "menu-commands-rewards",
  // },
  // {
  //   page: Page.LOYALTY,
  //   url: "/configuration/loyalty-page",
  //   active: (
  //     <span
  //       className="material-symbols-sharp"
  //       style={{ color: "var(--oda-color-800)", marginRight: "3px" }}
  //     >
  //       loyalty
  //     </span>
  //   ),
  //   nonactive: (
  //     <span
  //       className="material-symbols-sharp"
  //       style={{ color: "var(--oda-color-500)", marginRight: "3px" }}
  //     >
  //       loyalty
  //     </span>
  //   ),
  //   label: "menu-loyalty",
  // },
  {
    page: Page.HISTORY,
    url: "/configuration/history-page",
    active: <HistoryIcon color="var(--oda-color-800)" />,
    nonactive: <HistoryIcon color="var(--oda-color-500)" />,
    label: "menu-history",
  },
  {
    page: Page.BOTS,
    url: "/configuration/bots",
    active: (
      <span
        className="material-symbols-sharp"
        style={{ color: "var(--oda-color-800)", marginRight: "3px" }}
      >
        robot_2
      </span>
    ),
    nonactive: (
      <span
        className="material-symbols-sharp"
        style={{ color: "var(--oda-color-500)", marginRight: "3px" }}
      >
        robot_2
      </span>
    ),
    label: "menu-bots",
  },
  {
    page: Page.PAYMENTPAGE,
    url: "/configuration/payment-page",
    active: <RubleIcon color="var(--oda-color-800)" />,
    nonactive: <RubleIcon color="var(--oda-color-500)" />,
    label: "menu-payment-page-config",
  },
  {
    page: Page.GATEWAYS,
    url: "/configuration/gateways",
    active: <WalletIcon color="var(--oda-color-800)" />,
    nonactive: <WalletIcon color="var(--oda-color-500)" />,
    label: "menu-gateways",
  },
  {
    page: Page.INTEGRATIONS,
    url: "/configuration/integrations",
    active: <IntegrationIcon color="var(--oda-color-800)" />,
    nonactive: <IntegrationIcon color="var(--oda-color-500)" />,
    label: "menu-integrations",
  },
  {
    page: Page.AUTOMATION,
    url: "/configuration/automation-page",
    active: <AutomationIcon color="var(--oda-color-800)" />,
    nonactive: <AutomationIcon color="var(--oda-color-500)" />,
    label: "menu-automation",
  },
  {
    page: Page.GUIDES,
    url: "/configuration/guides",
    active: <GuideIcon color="var(--oda-color-800)" />,
    nonactive: <GuideIcon color="var(--oda-color-500)" />,
    label: "menu-guides",
  },
  {
    page: Page.API,
    url: "/configuration/api",
    active: <span className="material-symbols-sharp">extension </span>,
    nonactive: <span className="material-symbols-sharp">extension </span>,
    label: "menu-api",
  },
  {
    page: Page.ACCOUNT,
    url: "/configuration/account",
    active: <span className="material-symbols-sharp">manage_accounts</span>,
    nonactive: <span className="material-symbols-sharp">manage_accounts</span>,
    label: "menu-account",
  },
];

function NewFeature({
  children,
  className,
  show,
}: {
  children: ReactNode;
  className?: string;
  show?: boolean;
}) {
  return (
    <div className={`${classes.wrapper} ${className ?? ""}`}>
      {show && <span className={`${classes.newfeature}`}>new</span>}
      {children}
    </div>
  );
}

export default function Toolbar({ page }: { page: Page }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { features } = useLoaderData() as WidgetData;
  const [buttons, setButtons] = useState<Section[]>([]);

  useEffect(() => {
    if (features.find((f) => f.name === "Bots")?.state === "ENABLED") {
      setButtons(allButtons);
    } else {
      setButtons(allButtons.filter((b) => b.page !== Page.BOTS));
    }
  }, [features]);

  return (
    <div className={`${style.toolbar}`}>
      {buttons.map((button) => (
        <NewFeature show={button.page === Page.WIDGETS} key={button.label}>
          <button
            key={button.label}
            className={`${style.button} ${
              page === button.page ? "selected" : "inactive"
            }`}
            onClick={() => navigate(button.url)}
          >
            {page === button.page ? button.active : button.nonactive}
            <span className={`${classes.toolbarbuttontitle}`}>
              {t(button.label)}
            </span>
          </button>
        </NewFeature>
      ))}
      <NewsComponent />
    </div>
  );
}

export { Page };
